<template>
    <v-container fluid pa-0>
        <v-row class="justify-content-center">
            <v-col md="6" sm="12">
                <my-submissions-header
                    :submit-again-url="submitAgainUrl"
                    :button-color="buttonColor"
                    :button-text-color="buttonTextColor"
                    :logo-url="logoUrl"
                    :page-name="pageName"
                    :hall-of-fame-url="hallOfFameUrl"
                    :hall-of-fame-enabled="hallOfFameEnabled"
                />
            </v-col>
        </v-row>
        <v-row class="justify-content-center">
            <div class="ad-row">
                <google-ad unit="300_250_unit" />
            </div>
        </v-row>
        <v-row class="justify-content-center">
            <v-progress-circular
                v-if="this.loading"
                indeterminate
                :size="50"
                :width="5"
            />
            <v-col v-else md="6" sm="12">
                <v-card v-if="this.submissionsWithAds.length == 0">
                    <v-card-title>You've not made any submissions!</v-card-title>
                </v-card>
                <template v-else>
                    <submission-trackers-list-item v-for="submission in this.submissionsWithAds" :key="submission.id" :tracker="submission" />
                </template>
            </v-col>
        </v-row>
        <v-row class="justify-content-center">
            <div class="ad-row">
                <google-ad unit="300_250_unit" />
            </div>
        </v-row>
    </v-container>
</template>

<script>
import SubmissionTrackersListItem from './SubmissionTrackersListItem';
import mySubmissionsHeader from "./mySubmissionsHeader"
export default {
    name: 'SubmissionTrackersList',

    components: {
        SubmissionTrackersListItem,
        mySubmissionsHeader,
    },

    props: {
        id: String,
        "submissions-api-url": String,
        "submit-again-url": String,
        "button-color": String,
        "button-text-color": String,
        "logo-url": String,
        "page-name": String,
        "hall-of-fame-url": String,
        "hall-of-fame-enabled": String,
    },

    data() {
        return {
            submissionsWithAds: [],
            loading: true,
        };
    },

    methods: {
        retrieveSubmissionIds() {
            if (localStorage.getItem(this.id)) {
                let parsed = JSON.parse(localStorage.getItem(this.id));
                if ('apiVersion' in parsed && parsed.apiVersion == '1.0') {
                    return parsed.ids;
                }
            }
            return [];
        },
        async retrieveSubmissions(submissionIds) {
            const response = await axios.get(
                this.submissionsApiUrl, {
                    params: {
                        ids: submissionIds,
                    }
                }
            );
            return response.data;
        },
        addAds(submissions) {
            let submissionsWithAds = [];
            for (let i=0; i<submissions.length; i++) {
                submissionsWithAds.push(submissions[i]);
                if ((i+1)%2 == 0) {
                    submissionsWithAds.push({
                        id: `ad${i}`,
                        ad: true
                    });
                }
            }
            return submissionsWithAds;
        }
    },

    async mounted() {
        let submissionIds = this.retrieveSubmissionIds();
        let submissions = await this.retrieveSubmissions(submissionIds);
        this.submissionsWithAds = this.addAds(submissions);
        this.loading = false;
    },
};
</script>

<style scoped>
    .ad-row {
        min-width: 320px;
        max-height: 250px;
    }
</style>